export default __webpack_public_path__ + "static/media/excel2016.50c1ba67.png";